import { z } from 'zod';

export const hospitalCodeSchema = z
  .string()
  .regex(/^(?:[0-9]{3}| {3})$/, 'Hospital Code must be 3 digits or 3 spaces');

export const hospitals = [
  { region: 'B', code: '001', name: 'Brandon General Hospital' },
  { region: 'W', code: '003', name: 'Grace Hospital' },
  {
    region: 'W',
    code: '004',
    name: 'Misericordia Health Centre (Misericordia General Hospital)',
  },
  {
    region: 'W',
    code: '005',
    name: 'St. Boniface General Hospital (SBH)',
  },
  { region: 'W', code: '006', name: 'Riverview Health Centre' },
  { region: 'W', code: '007', name: 'Victoria General Hospital' },
  { region: 'W', code: '008', name: 'Health Sciences Centre' },
  { region: 'W', code: '009', name: 'Concordia Hospital' },
  { region: 'W', code: '011', name: 'Seven Oaks General Hospital' },
  { region: 'W', code: '016', name: 'Health Sciences Centre (HSC)' },
  {
    region: 'W',
    code: '017',
    name: 'Rehabilitation Centre for Children',
  },
  {
    region: 'W',
    code: '020',
    name: 'Manitoba Adolescent Treatment Centre',
  },
  { region: 'W', code: '026', name: 'Jocelyn House' },
  { region: 'W', code: '030', name: 'Western Surgery Centre' },
  { region: 'W', code: '036', name: 'Pan Am Surgical Centre' },
  {
    region: 'R',
    code: '046',
    name: 'Selkirk Mental Health Centre (SMHC)',
  },
  {
    region: 'R',
    code: '052',
    name: 'Lac du Bonnet District Health Centre',
  },
  {
    region: 'W',
    code: '064',
    name: 'St. Amant Health and Transition Services',
  },
  {
    region: 'R',
    code: '102',
    name: 'Altona Community Memorial Health Centre',
  },
  { region: 'R', code: '103', name: 'Arborg & District Health Centre' },
  { region: 'R', code: '106', name: 'Baldur Health Centre' },
  { region: 'R', code: '107', name: 'Beausejour Hospital' },
  { region: 'R', code: '108', name: 'Benito Health Centre' },
  { region: 'R', code: '110', name: 'Bethesda Regional Health Centre' },
  { region: 'N', code: '111', name: 'Snow Lake Health Clinic' },
  { region: 'R', code: '113', name: 'Boissevain Health Centre' },
  {
    region: 'R',
    code: '114',
    name: 'Boundary Trails Health Centre (Winkler & Morden)',
  },
  { region: 'R', code: '116', name: 'Carman Memorial Hospital' },
  {
    region: 'R',
    code: '117',
    name: 'Cartwright Davidson Memorial Health Centre',
  },
  {
    region: 'R',
    code: '118',
    name: 'Winnipegosis and District Health Centre',
  },
  {
    region: 'R',
    code: '119',
    name: 'Rock Lake Health District Hospital',
  },
  {
    region: 'R',
    code: '122',
    name: 'Dauphin Regional Health Centre',
  },
  { region: 'R', code: '123', name: 'Deloraine Health Centre' },
  {
    region: 'R',
    code: '124',
    name: 'De Salaberry District Health Centre',
  },
  { region: 'R', code: '125', name: 'Eden Mental Health Centre' },
  {
    region: 'R',
    code: '128',
    name: 'Elizabeth M. Crowe Memorial Hospital',
  },
  {
    region: 'R',
    code: '129',
    name: 'Erickson & District Health Centre',
  },
  { region: 'C', code: '130', name: 'Churchill Health Centre' },
  { region: 'R', code: '131', name: 'Emerson Health Centre' },
  { region: 'N', code: '134', name: 'Flin Flon General Hospital' },
  { region: 'R', code: '135', name: 'Carberry Health Centre' },
  { region: 'C', code: '136', name: 'Gillam Hospital' },
  {
    region: 'R',
    code: '138',
    name: 'Seven Regions/Gladstone Health Centre',
  },
  { region: 'R', code: '139', name: 'Glenboro Health Centre' },
  { region: 'R', code: '140', name: 'Grandview Health Centre' },
  {
    region: 'R',
    code: '142',
    name: 'Hartney Community Health Centre',
  },
  { region: 'R', code: '143', name: 'Hamiota Health Centre' },
  {
    region: 'R',
    code: '144',
    name: 'Teulon-Hunter Memorial Health District',
  },
  {
    region: 'R',
    code: '146',
    name: 'Johnson Memorial Hospital  (Gimli Community Health Centre)',
  },
  { region: 'R', code: '147', name: 'Lorne Memorial Hospital' },
  { region: 'R', code: '148', name: 'Tri-Lake Health Centre' },
  { region: 'N', code: '149', name: 'Lynn Lake Hospital/Leaf Rapids' },
  {
    region: 'R',
    code: '150',
    name: 'McCreary/Alonsa Health Centre',
  },
  { region: 'R', code: '151', name: 'Pembina-Manitou Health Centre' },
  { region: 'R', code: '152', name: 'Minnedosa Health Centre' },
  { region: 'R', code: '154', name: 'Morris General Hospital' },
  { region: 'N', code: '155', name: 'Leaf Rapids Health Centre' },
  { region: 'R', code: '156', name: 'MacGregor Health Centre' },
  { region: 'R', code: '158', name: 'Neepawa Health Centre' },
  { region: 'R', code: '159', name: 'Notre Dame Health Centre' },
  { region: 'R', code: '161', name: 'Pine Falls Hospital' },
  {
    region: 'R',
    code: '162',
    name: 'Portage District Health Centre (PDH)',
  },
  { region: 'R', code: '163', name: 'Pinawa Hospital' },
  { region: 'R', code: '164', name: 'Reston Health Centre' },
  { region: 'R', code: '165', name: 'Roblin Health Centre' },
  { region: 'R', code: '167', name: 'Rossburn Health Centre' },
  { region: 'R', code: '169', name: 'Russell Health Centre' },
  { region: 'N', code: '170', name: "St. Anthony's General Hospital" },
  { region: 'R', code: '171', name: 'Birtle Health Centre' },
  {
    region: 'R',
    code: '172',
    name: 'Ste. Rose General Hospital',
  },
  { region: 'R', code: '173', name: 'Selkirk Regional Health Centre' },
  {
    region: 'R',
    code: '174',
    name: 'Shoal Lake/Strathclair Health Centre',
  },
  { region: 'R', code: '175', name: 'Souris Health Centre' },
  {
    region: 'R',
    code: '176',
    name: 'Stonewall & District Health Centre',
  },
  {
    region: 'R',
    code: '177',
    name: 'Swan Valley Health Centre',
  },
  { region: 'R', code: '178', name: 'Lakeshore General Hospital' },
  { region: 'R', code: '179', name: 'Ste. Anne Hospital' },
  { region: 'R', code: '180', name: 'Virden Health Centre' },
  { region: 'R', code: '181', name: 'Vita & District Health Centre' },
  { region: 'R', code: '182', name: 'St. Claude Health Centre' },
  { region: 'R', code: '183', name: 'Treherne Health Centre' },
  { region: 'R', code: '184', name: 'Melita Health Centre' },
  {
    region: 'R',
    code: '185',
    name: 'Whitemouth District Health Centre',
  },
  { region: 'R', code: '186', name: 'Wawanesa Health Centre' },
  { region: 'N', code: '187', name: 'Thompson General Hospital' },
  {
    region: 'W',
    code: '198',
    name: 'Grace Hospital - Transitional Care Unit',
  },
  { region: 'W', code: '200', name: 'Deer Lodge Centre' },
  { region: 'W', code: '206', name: 'Greenwood Dental' },
  { region: 'C', code: '210', name: 'Percy E. Moore Hospital' },
  { region: 'C', code: '212', name: 'Norway House Hospital' },
  { region: 'W', code: '214', name: "Men's Health Clinic" },
  { region: 'W', code: '217', name: 'Just 4 Kids' },
  { region: 'W', code: '220', name: 'Seven Oaks General Hospital' },
  { region: 'C', code: '271', name: 'Cross Lake Nursing Station' },
  { region: 'C', code: '273', name: 'Garden Hill Nursing Station' },
  { region: 'C', code: '277', name: 'Nelson House Nursing Station' },
  { region: 'N', code: '278', name: 'Oxford House Nursing Station' },
  { region: 'C', code: '279', name: 'Split Lake Nursing Station' },
  { region: 'C', code: '282', name: 'Brochet Nursing Station' },
  {
    region: 'C',
    code: '283',
    name: 'South Indian Lake Nursing Station',
  },
  { region: 'C', code: '290', name: 'Lac Brochet Nursing Station' },
  { region: 'C', code: '291', name: 'Gods River Nursing Station' },
  { region: 'C', code: '292', name: 'Tadoule Lake Nursing Station' },
  { region: 'C', code: '293', name: 'York Landing Nursing Station' },
  { region: 'W', code: '372', name: 'Childrens Dental World' },
  { region: 'W', code: '396', name: 'CTU-Ward A' },
  { region: 'W', code: '398', name: 'Maples Surgery Center' },
  { region: 'W', code: '399', name: 'CTU - Grace Hospital' },
  {
    region: 'B',
    code: '501',
    name: 'Rideau Park Personal Care Home',
  },
  { region: 'R', code: '504', name: 'Kin Place Personal Care Home' },
  { region: 'W', code: '506', name: 'Calvary Place Personal Care Home' },
  { region: 'W', code: '508', name: 'Beacon Hill Lodge' },
  { region: 'W', code: '509', name: 'Misericordia Place' },
  { region: 'W', code: '512', name: 'Southeast Personal Care Home' },
  { region: 'N', code: '515', name: 'Northern Spirit Manor' },
  { region: 'W', code: '521', name: 'Poseidon Care Centre' },
  { region: 'B', code: '529', name: 'Valleyview Care Centre' },
  { region: 'W', code: '551', name: 'Golden Door Geriatric Centre' },
  { region: 'R', code: '552', name: 'Gilbert Plains Care Home' },
  {
    region: 'R',
    code: '554',
    name: 'Willowview Personal Care Home',
  },
  { region: 'W', code: '555', name: 'Heritage Lodge P.C.H.' },
  {
    region: 'R',
    code: '556',
    name: 'Fisher Branch Personal Care Home',
  },
  {
    region: 'B',
    code: '557',
    name: 'Hillcrest Personal Care Home',
  },
  { region: 'W', code: '559', name: 'Charleswood Care Centre' },
  { region: 'W', code: '564', name: 'Kildonan Personal Care Centre' },
  {
    region: 'R',
    code: '566',
    name: 'Lac du Bonnet Personal Care Home',
  },
  { region: 'W', code: '568', name: 'Maples Personal Care Home' },
  {
    region: 'N',
    code: '570',
    name: 'Nisichawayasihk Personal Care Home',
  },
  { region: 'W', code: '571', name: 'Oakview Place (Extendicare)' },
  { region: 'W', code: '573', name: 'Concordia Place' },
  {
    region: 'W',
    code: '574',
    name: 'River East Personal Care Home Ltd.',
  },
  { region: 'W', code: '581', name: 'St. Norbert Personal Care Home' },
  { region: 'R', code: '583', name: 'Red River Place' },
  { region: 'R', code: '584', name: 'Hartney Health Centre' },
  { region: 'W', code: '587', name: 'Riverview Health Centre PCH' },
  { region: 'R', code: '589', name: 'Benito Health Centre' },
  { region: 'R', code: '591', name: 'Elkwood Manor' },
  { region: 'R', code: '592', name: 'Douglas Campbell Lodge' },
  { region: 'R', code: '593', name: 'Tudor House Personal Care Home' },
  { region: 'W', code: '594', name: 'Tuxedo Villa Nursing Home' },
  { region: 'W', code: '595', name: 'Vista Park Lodge' },
  { region: 'W', code: '596', name: 'West Park Manor PCH' },
  {
    region: 'R',
    code: '597',
    name: 'Sunnywood Manor Personal Care Home',
  },
  {
    region: 'B',
    code: '599',
    name: 'Dinsdale Personal Care Home',
  },
  {
    region: 'R',
    code: '601',
    name: 'Bayside Personal Care Home',
  },
  { region: 'R', code: '602', name: 'Baldur Manor' },
  { region: 'R', code: '603', name: 'Betel Home - Gimli' },
  { region: 'R', code: '605', name: 'Betel PCH - Selkirk' },
  { region: 'R', code: '606', name: 'Eriksdale Personal Care Home' },
  { region: 'W', code: '607', name: 'Bethania Mennonite PCH Inc' },
  { region: 'R', code: '609', name: 'Bethesda place' },
  {
    region: 'R',
    code: '610',
    name: 'Evergreen Place Personal Care Home',
  },
  { region: 'R', code: '611', name: 'Boyne Lodge Personal Care Home' },
  { region: 'R', code: '613', name: 'Bren-Del-Win Lodge' },
  {
    region: 'R',
    code: '614',
    name: 'Dauphin Personal Care Home',
  },
  {
    region: 'W',
    code: '615',
    name: 'The Saul and Claribel Simkin Centre',
  },
  {
    region: 'R',
    code: '616',
    name: 'Carberry Personal Care Home',
  },
  {
    region: 'W',
    code: '617',
    name: 'The Convalescent Home of Winnipeg',
  },
  {
    region: 'R',
    code: '618',
    name: 'Delwynda Court Personal Care home',
  },
  { region: 'W', code: '619', name: 'Donwood Manor P.C.H.' },
  { region: 'R', code: '620', name: 'East-Gate Lodge' },
  {
    region: 'R',
    code: '621',
    name: 'Country Meadows Personal Care Home',
  },
  { region: 'N', code: '622', name: 'Flin Flon Personal Care Home' },
  { region: 'R', code: '623', name: 'Ebenezer Home For The Aged' },
  {
    region: 'B',
    code: '625',
    name: 'Fairview Personal Care Home',
  },
  { region: 'W', code: '626', name: 'Actionmarguerite (St. Vital)' },
  { region: 'W', code: '627', name: 'River Park Gardens' },
  { region: 'W', code: '628', name: 'Fred Douglas Lodge' },
  { region: 'R', code: '629', name: 'Foyer Notre Dame' },
  {
    region: 'R',
    code: '631',
    name: 'Goodwin Lodge Personal Care Home',
  },
  { region: 'W', code: '632', name: 'Golden West Centennial Lodge' },
  {
    region: 'R',
    code: '633',
    name: 'Grandview Personal Care Home',
  },
  { region: 'R', code: '634', name: 'Heritage Life Personal Care Home' },
  { region: 'W', code: '635', name: 'Holy Family Nursing Home' },
  { region: 'W', code: '636', name: 'Pembina Place Mennonite PCH' },
  {
    region: 'R',
    code: '638',
    name: 'Dr. Gendreau Personal Care Home',
  },
  { region: 'W', code: '639', name: 'Lions Personal Care Home' },
  { region: 'R', code: '640', name: 'Lions Prairie Manor' },
  {
    region: 'R',
    code: '641',
    name: 'McCreary/Alonsa Personal Care Home',
  },
  { region: 'W', code: '642', name: 'Meadowood Manor' },
  { region: 'W', code: '643', name: 'Luther Home' },
  { region: 'R', code: '645', name: 'Repos Jolys Personal Care Home' },
  { region: 'R', code: '646', name: 'Menno Home for the Aged' },
  {
    region: 'R',
    code: '648',
    name: 'Minnedosa Personal Care Home',
  },
  {
    region: 'W',
    code: '649',
    name: 'The Middlechurch Home of Winnipeg Inc.',
  },
  {
    region: 'R',
    code: '650',
    name: 'Morley House Personal Care Home',
  },
  {
    region: 'R',
    code: '652',
    name: 'Melita Personal Care Home',
  },
  { region: 'N', code: '653', name: 'Northern Lights Manor' },
  { region: 'R', code: '654', name: 'Rock Lake Health District PCH' },
  {
    region: 'R',
    code: '656',
    name: 'Pioneer Health Services/Arborg PCH',
  },
  { region: 'W', code: '657', name: 'Park Manor Care Home' },
  { region: 'N', code: '658', name: 'Pinaow Wachi' },
  { region: 'R', code: '659', name: 'Prairie View Lodge' },
  { region: 'R', code: '661', name: 'Red River Valley Lodge' },
  { region: 'R', code: '662', name: 'Rest Haven Care Home' },
  {
    region: 'R',
    code: '663',
    name: 'Rosewood Lodge Personal Care Home',
  },
  {
    region: 'R',
    code: '664',
    name: 'Russell Personal Care Home',
  },
  {
    region: 'R',
    code: '666',
    name: 'Roblin Crocus Court Personal Care Home',
  },
  { region: 'W', code: '667', name: 'Actionmarguerite (St. Joseph)' },
  { region: 'N', code: '669', name: "St. Paul's Home" },
  {
    region: 'R',
    code: '671',
    name: 'Riverdale Health Centre/PCH',
  },
  { region: 'R', code: '672', name: 'Salem Home Inc.' },
  {
    region: 'R',
    code: '677',
    name: 'Birch Lodge Personal Care Home',
  },
  {
    region: 'R',
    code: '678',
    name: 'Sandy Lake Personal Care Home',
  },
  { region: 'R', code: '679', name: 'Vita & District Health Centre' },
  { region: 'W', code: '681', name: 'Sherwood Nursing Home' },
  {
    region: 'R',
    code: '682',
    name: 'Souris Personal Care Home',
  },
  { region: 'R', code: '683', name: 'Swan Valley Lodge' },
  {
    region: 'R',
    code: '684',
    name: 'Sawn River Valley Personal Care Home',
  },
  { region: 'W', code: '685', name: 'Golden Links Lodge P.C.H.' },
  { region: 'R', code: '686', name: 'Tabor Home Inc.' },
  { region: 'R', code: '687', name: 'Tigers Hills Manor' },
  { region: 'W', code: '688', name: 'Actionmarguerite (St. Boniface)' },
  { region: 'R', code: '689', name: 'Third Crossing Manor' },
  { region: 'R', code: '691', name: 'MacGregor Health Centre' },
  {
    region: 'R',
    code: '692',
    name: 'Rossburn Personal Care Home',
  },
  { region: 'R', code: '693', name: 'Villa Youville' },
  { region: 'R', code: '695', name: 'West-Man Nursing Home' },
  {
    region: 'R',
    code: '696',
    name: 'Westview Lodge Personal Care Home',
  },
  {
    region: 'R',
    code: '697',
    name: 'Winnipegosis & District Personal Care Home',
  },
  {
    region: 'R',
    code: '698',
    name: 'Glenboro Personal Care Home',
  },
  { region: 'W', code: '699', name: 'Deer Lodge Centre PC' },
] as const;

export type HospitalCode = (typeof hospitals)[number]['code'];

export const hospitalOptions = hospitals.map(({ code, name }) => ({
  value: code,
  label: `${code} - ${name}`,
}));

export const hospitalCodeNameMap: Record<string, string> = Object.fromEntries(
  hospitals.map(({ code, name }) => [code, name])
);

export const hospitalCodes = hospitals.map(({ code }) => code) as [
  string,
  ...string[]
];

export const knownHospitalCodeSchema = z.enum(hospitalCodes);

export const getHospitalNameForCode = (
  hospitalCode?: string | null
): string | null => {
  const code = hospitalCode?.trim();
  if (!code) return null;
  return hospitalCodeNameMap[code] ?? null;
};

export const isKnownHospitalCode = (hospitalCode?: string | null): boolean => {
  const code = hospitalCode?.trim();
  if (!code) return false;
  return code in hospitalCodeNameMap;
};
